
export enum AcctHeadType {
  None = 0,
  OIM = 1,    // Ocean Import Master
  OIH,        // Ocean Import House
  OEM,        // Ocean Export Master
  OEH,        // Ocean Export House
  AIM,        // Air Import Master
  AIH,        // Air Import House
  AEM,        // Air Export Master
  AEH,        // Air Export House
  OTH,        // Other Shipment
  WHR,        // Warehouse Receive
  WHS,        // Warehouse Shipping

  STG,        // Storage Invoice (General 과 유사한 구성)
  GEN,        // General Invoice (Bill)
  PRD,        // Period Invoice

  FRCV,       // Fulfillment Receive
  FOE,        // Fulfillment
  FSTG,       // Fuifillment Storage
  ETRY,       // CHB Entry
  OTOP,       // Other Operation for Hybrid

  ECLM,       // iXPense
}


export enum AcctModeType
{
    OIOrignCost = 111,
    OIOriginSales = 112,
    OIDestinationCost = 121,
    OIDestinationSales = 122,
    OIOtherCost = 131,
    OIOtherSale = 132,
    WHOriginCost = 141,            // jejeon 220801 Warehousing Sales/Cost
    WHOriginSale = 142,            // jejeon 220801 Warehousing Sales/Cost
    WHCost = 151,                  // jejeon 220805 Warehousing Bill
    WHSale = 152,                  // jejeon 220805 Warehousing Invoice
    WHCrDb = 153,
    OEOriginCost = 221,            // <chuck CrDbJournal date = "2017-12-21" />
    OEOriginSales = 222,           // <chuck CrDbJournal date = "2017-12-21" />
    CrDbImport = 311,              // <chuck date="2023-09-15" desc="Add for CrDb ChgType" />
    CrDbExport = 312,              // <chuck date="2023-09-15" desc="Add for CrDb ChgType" />
    CrDbSalesIDS = 321,
    CrDbCostIDS = 322,
    CrDbSalesDS = 323,
    CrDbCostDS = 324,
}

export enum ChgType {
    None = 0,
    // Sales Part  --------------------
    Sales = 1,
    Collect4Agt,
    ICSales,
    TransSale,

    DueFromAgent = 5,
    OurSales,
    TheirSales,

    DutyLoanA = 8,
    OtherSales,
    DutyLoanC,

    // Cost Part  --------------------
    Cost = 11,

    Pay4Agt,
    Cost2Agt,
    Cost4Transit,

    DueToAgent = 15,
    OurCost,
    TheirCost,

    DutyLoan2Agent = 18,
    OtherCost = 19,
    DutyLoan2Customer,

    // Sales Part  --------------------
    SalesPSOnly = 27,               // DS, IDS - Our Sales (PS Only)  '' <chuck date = "2019-06-04" />
    DutyCustomer = 30,
    // Cost Part  --------------------
    CostPSOnly = 37,                // DS, IDS - Our Sales (PS Only)  '' <chuck date = "2019-06-04" />
    DutyAgent = 38,
    DutyPay4Customer = 40           // DS, IDS - Duty pay for Customer  Used in Export Cost   '' <chuck CrDbJournal date = "2017-12-19" />
}

export enum LocCode
{
    Origin = 1,
    Destination
}

export enum FormType {
  None = '',
  ModeAdd = 'add',
  ModeEdit = 'edit',
  ModeView = 'view',
  ModeCopy = 'copy',
  ModeNone = 'none',
  ModeDelete = 'delete',
  ModeMerge = 'merge',
  ModeChange = 'change',
  ModeRCopy = 'rcopy',
  ModeList = 'list',
}
export enum FormSubType {
    //None = 0,
    None = 'none',
    Add = 'add',
    View = 'view',

    CreditLock = 'creditLock',         // click edit with Credited Invoice        
    CreditInvo = 'creditInvo',         // click edit with Credit Invoice        
    VoidLock = 'voidLock',           // click edit with Voided Invoice        
    VoidInvo = 'voidInvo',           // click edit with Void Invoice        
    GiveCreditInvo = 'giveCreditInvo',     // click edit with Give Credit Invoice        

    // Action Status
    Amend = 'amend',              // Clicked the Amend Button
    NoRevise = 'noRevise',           // Clicked the Amend Button after clicked the No button on Revise Confirm Message.
    Revise = 'revise',             // Clicked the Yes button on Revise Confirm Message.
    Credit = 'credit',             // Clicked the Credit Button
    Void = 'void',               // Clicked the Void Button
    GiveCredit = 'giveCredit',         // Clicked the Give Credit Button
    CancelCredit = 'cancelCredit',       // Clicked the Cancel Credit Button
    CancelGiveCredit = 'cancelGiveCredit',   // Clicked the Cancel Give Credit Button
    CCPay = 'CCpay',                    // Clicked the CC Pay Button
    PaidAmend = 'paidAmend',
}

export function getBillingCodeTypeFromAcctHeadType(acctType: AcctHeadType):string {
  switch(acctType) {
    case AcctHeadType.OIM:
    case AcctHeadType.OIH:
      return 'OI';
    case AcctHeadType.OEH:
    case AcctHeadType.OEM:
      return 'OO';
    case AcctHeadType.AIH:
    case AcctHeadType.AIM:
      return 'AI';
    case AcctHeadType.AEH:
    case AcctHeadType.AEM:
      return 'AO';
    case AcctHeadType.OTH:
      return 'OT';
    case AcctHeadType.WHR:
    case AcctHeadType.WHS:
    case AcctHeadType.STG:
      return 'WH';
    case AcctHeadType.GEN:
      return 'GE';
    default: return '';
  }
}

export function getAcctHeadTypeByTBName(tbName:string): AcctHeadType {
  switch(tbName.toUpperCase()) {
    case "T_OIMMAIN": return AcctHeadType.OIM;
    case "T_OIHMAIN": return AcctHeadType.OIH;
    case "T_OOMMAIN": return AcctHeadType.OEM;
    case "T_OOHMAIN": return AcctHeadType.OEH;
    case "T_AIMMAIN": return AcctHeadType.AIM;
    case "T_AIHMAIN": return AcctHeadType.AIH;
    case "T_AOMMAIN": return AcctHeadType.AEM;
    case "T_AOHMAIN": return AcctHeadType.AEH;
    case "T_GENMAIN": return AcctHeadType.OTH;
    case "T_WRECEIVE": return AcctHeadType.WHR;
    case "T_WRECEIVEHD": return AcctHeadType.WHR;
    case "T_WSHIPHD": return AcctHeadType.WHS;

    case "T_STORAGE": return AcctHeadType.STG;
    case "":		  return AcctHeadType.GEN;
    case "T_WHPERIOD": return AcctHeadType.PRD;

    case "FRCV":	  return AcctHeadType.FRCV;
    case "FOE":		  return AcctHeadType.FOE;
    case "FSTG":	  return AcctHeadType.FSTG;
    case "ETRY":	  return AcctHeadType.ETRY;
    case "OTOP":	  return AcctHeadType.OTOP;
  }
  return AcctHeadType.GEN;
}

export enum SecType
{
  Read,
  Add,
  Edit,
  Delete,
  YesOrNo
}

export enum SiteLogType {
  AmsWeb = 1,
  IsfWeb,
  IsfFiling,
  AciWeb,
}